<div class="nk-content nk-content-fluid">
  <div class="container-xl wide-xl">
    <div class="nk-content-inner">

      <app-back [visivel]="isVisivel"></app-back>

      <div class="nk-content-body">
        <div class="components-preview">
          <div class="nk-block-head nk-block-head-lg wide-xl">
            <div class="nk-block-head-content">
              <h4 class="nk-block-title fw-bold text-center">{{'segredo_estatistico'|translate}}</h4>
              <div class="nk-block-des text-center justify-center align-center mt-4">
                <div class="alert alert-pro alert-primary">
                  <div class="alert-text">
                    <h6 id="alert_msg">{{'alert_msg'|translate}}</h6>
                    <p>{{'info'|translate}} </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="nk-block nk-block-lg">
            <div class="card card-bordered">
              <form #form="ngForm" (submit)="onSubmit(form)" class="nk-stepper stepper-init is-alter nk-stepper-s1"
                id="stepper-create-project" autocomplete="off">
                <div class="row g-0 col-sep col-sep-md col-sep-xl">
                  <div class="col-md-4 col-xl-4 d-none d-md-block">
                    <div class="card-inner">
                      <ul class="nk-stepper-nav nk-stepper-nav-s1 stepper-nav is-vr">
                        <!-- <li>
                          <div class="step-item">
                            <div class="step-text">
                              <div class="lead-text">{{'inicio'|translate}}</div>
                            </div>
                          </div>
                        </li> -->
                        <li>
                          <div class="step-item">
                            <div class="step-text">
                              <div class="lead-text">{{'identificacao'|translate}}</div>
                            </div>
                          </div>
                        </li>
                        <li *ngIf="mdcService.selectedI2Control && mdcService.isSelectedPais">
                          <div class="step-item">
                            <div class="step-text">
                              <div class="lead-text">{{'sessao'|translate}} I</div>
                              <div class="sub-text">{{'sessao_i'|translate}}</div>
                            </div>
                          </div>
                        </li>
                        <li *ngIf="mdcService.selectedI2Control && mdcService.isSelectedPais">
                          <div class="step-item">
                            <div class="step-text">
                              <div class="lead-text">{{'sessao'|translate}} II</div>
                              <div class="sub-text">{{'sessao_ii'|translate}}</div>
                            </div>
                          </div>
                        </li>
                        <li
                          *ngIf="mdcService.selectedI2Control && mdcService.isSelectedPais && mdcService.formData.mdc_3! >= 15">
                          <div class="step-item">
                            <div class="step-text">
                              <div class="lead-text">{{'sessao'|translate}} III</div>
                              <div class="sub-text">{{'sessao_iii'|translate}}</div>
                            </div>
                          </div>
                        </li>
                        <li
                          *ngIf="mdcService.selectedI2Control && mdcService.isSelectedPais && mdcService.formData.mdc_3! >= 15">
                          <div class="step-item">
                            <div class="step-text">
                              <div class="lead-text">{{'sessao'|translate}} IV</div>
                              <div class="sub-text">{{'sessao_iv'|translate}}</div>
                            </div>
                          </div>
                        </li>
                        <li
                          *ngIf="mdcService.selectedI2Control && mdcService.isSelectedPais && mdcService.formData.mdc_3! >= 18">
                          <div class="step-item">
                            <div class="step-text">
                              <div class="lead-text">{{'sessao'|translate}} V</div>
                              <div class="sub-text">{{'sessao_v'|translate}}</div>
                            </div>
                          </div>
                        </li>
                        <li
                          *ngIf="mdcService.selectedI2Control && mdcService.isSelectedPais && mdcService.formData.mdc_3! >= 18">
                          <div class="step-item">
                            <div class="step-text">
                              <div class="lead-text">{{'sessao'|translate}} VI</div>
                              <div class="sub-text">{{'sessao_vi'|translate}}</div>
                            </div>
                          </div>
                        </li>
                        <li
                          *ngIf="mdcService.selectedI2Control && mdcService.isSelectedPais && mdcService.formData.mdc_3! >= 18">
                          <div class="step-item">
                            <div class="step-text">
                              <div class="lead-text">{{'sessao'|translate}} VII</div>
                              <div class="sub-text">{{'sessao_vii'|translate}}</div>
                            </div>
                          </div>
                        </li>
                        <li *ngIf="!authService.isAuthenticated()">
                          <div class="step-item">
                            <div class="step-text">
                              <div class="lead-text">{{'verification'|translate}}</div>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div class="step-item">
                            <div class="step-text">
                              <div class="lead-text">{{'fim'|translate}}</div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-8 col-xl-8">
                    <div class="card-inner">
                      <div class="nk-stepper-content">
                        <div class="nk-stepper-steps stepper-steps">
                          <!-- <div class="nk-stepper-step">
                            <h5 class="title mb-4 text-primary">{{'inicio'|translate}}</h5>
                            <div *ngIf="!mdcService.isLoading" class="col-lg-12">
                              <div class="form-group">
                                <label class="form-label mb-4">{{'person_surveyed'|translate}}<span
                                    class="text-danger">*</span></label>
                                <ul class="custom-control-group g-3 align-center flex-wrap">
                                  <li class="custom-control custom-radio custom-control-pro no-control">
                                    <input type="radio" id="checkDuplication_1" class="custom-control-input"
                                      name="checkDuplication" value="1" (change)="mdcService.onI2Change()" required>
                                    <label class="custom-control-label" for="checkDuplication_1">Sim</label>
                                  </li>
                                  <li class="custom-control custom-radio custom-control-pro no-control">
                                    <input type="radio" id="checkDuplication_2" class="custom-control-input"
                                      name="checkDuplication" value="2" (change)="mdcService.onI2Change()" required>
                                    <label class="custom-control-label" for="checkDuplication_2">Não</label>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div> -->
                          <div class="nk-stepper-step">
                            <app-step-intro></app-step-intro>
                          </div>
                          <div class="nk-stepper-step"
                            *ngIf="mdcService.selectedI2Control && mdcService.isSelectedPais">
                            <app-step-section-i></app-step-section-i>
                          </div>
                          <div class="nk-stepper-step"
                            *ngIf="mdcService.selectedI2Control && mdcService.isSelectedPais">
                            <app-step-section-ii></app-step-section-ii>
                          </div>
                          <div class="nk-stepper-step"
                            *ngIf="mdcService.isVisible(['mdc_21', 'mdc_21_outro', 'mdc_22', 'mdc_22_outro', 'mdc_23', 'mdc_24', 'mdc_25', 'mdc_25_outro', 'mdc_26', 'mdc_26_1', 'mdc_27_1', 'mdc_27_2', 'mdc_27_3'], mdcService.selectedI2Control && mdcService.isSelectedPais && mdcService.formData.mdc_3! >= 15, null)">
                            <app-step-section-iii></app-step-section-iii>
                          </div>
                          <div class="nk-stepper-step"
                            *ngIf="mdcService.isVisible(['mdc_28', 'mdc_29', 'mdc_29_outro', 'mdc_30', 'mdc_30_outro', 'mdc_31'], mdcService.selectedI2Control && mdcService.isSelectedPais && mdcService.formData.mdc_3! >= 15, null)">
                            <app-step-section-iv></app-step-section-iv>
                          </div>
                          <div class="nk-stepper-step"
                            *ngIf="mdcService.isVisible(['mdc_32', 'mdc_32_outro', 'mdc_33', 'mdc_34', 'mdc_34_outro', 'mdc_35_2', 'mdc_35_3', 'mdc_35_4', 'mdc_35_5', 'mdc_35_6', 'mdc_36', 'mdc_37', 'mdc_38', 'mdc_38_outro', 'mdc_39', 'mdc_39_outro'], mdcService.selectedI2Control && mdcService.isSelectedPais && mdcService.formData.mdc_3! >= 18, null)">
                            <app-step-section-v></app-step-section-v>
                          </div>
                          <div class="nk-stepper-step"
                            *ngIf="mdcService.isVisible(['mdc_40'], mdcService.selectedI2Control && mdcService.isSelectedPais && mdcService.formData.mdc_3! >= 18, null)">
                            <app-step-section-vi></app-step-section-vi>
                          </div>
                          <div class="nk-stepper-step"
                            *ngIf="mdcService.isVisible(['mdc_41', 'mdc_41_1_1', 'mdc_41_1_2'], mdcService.selectedI2Control && mdcService.isSelectedPais && mdcService.formData.mdc_3! >= 18, null)">
                            <app-step-section-vii> </app-step-section-vii>
                          </div>
                          <div class="nk-stepper-step" *ngIf="!authService.isAuthenticated()">
                            <app-step-verification></app-step-verification>
                          </div>
                          <div class="nk-stepper-step ">
                            <app-step-end></app-step-end>
                          </div>
                        </div>
                        <ul *ngIf="!mdcService.err_connection_refused"
                          class="nk-stepper-pagination pt-4 gx-4 gy-2 stepper-pagination">
                          <li class="step-prev"><button (click)="mdcService.cleanVerification()"
                              [disabled]="mdcService.prevValid()" type="button" class="btn btn-dim btn-primary"><em
                                class="icon ni ni-arrow-left me-1"></em>{{'anterior'|translate}}</button></li>
                          <li class="step-next"><button (click)="mdcService.verification()"
                              [disabled]="mdcService.nextValid()" type="button"
                              class="btn btn-primary">{{'proximo'|translate}}<em
                                class="icon ni ni-arrow-right ms-1"></em></button></li>
                          <li class="step-submit">
                            <button *ngIf="authService.isAuthenticated()"
                              [disabled]="isSubmitting || !form.valid" type="button"
                              (click)="onSubmitOffline()"
                              class="btn btn-secondary me-4 mb-4">{{'save_offline'|translate}}<em
                                class="icon ni ni-download ms-1"></em></button>
                            <button type="submit" [disabled]="isSubmitting || !form.valid"
                              class="btn btn-success mb-4">{{'submeter'|translate}}<em
                                class="icon ni ni-send ms-1"></em></button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>